<template>
  <div>
    <div class="AllShowMapToUSer">
      <div v-if="closeBtn1" class="TextRightAllShowMapToUSer">
        <el-scrollbar class="ShowToUserApartments">
          <div class="createMelkHeader phoneBookHeader showFileHeader">
            <div class="createMelkHeaderContainer">
              <div class="createMelkHeaderTitle">
                <h1>آگهی‌ها</h1>
              </div>
              <div @click="closeBtn" class="ShowIconVsIcon">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
          </div>

          <div
            v-if="filteredProperties == '' && isLoading"
            style="margin-top: 30px"
            class="apartmentsListContainer"
          >
            <Skeletor
              v-for="(v, i) in 12"
              :key="i"
              class="ChildShowTabToUserCustomer sliderBottm"
              height="200"
              style="
                background: rgb(163, 219, 213);
                margin-bottom: 2rem;
                border-radius: 10px;
              "
            />
          </div>
          <div
            v-show="filteredProperties != '' && !isLoading"
            class="apartmentsListContainer"
          >
            <div
              class="propertyThumb"
              v-for="(apartment, i) in filteredProperties"
              @click="showPost(apartment, i)"
              :key="apartment.id"
            >
              <div class="propertyPic">
                <div class="propertyNums">
                  <div class="likesNum">
                    <div class="numsICON">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                    </div>
                    <div class="numNumber">{{ apartment.likes }}</div>
                  </div>
                  <div class="commentsNum">
                    <div class="numsICON">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                        />
                      </svg>
                    </div>
                    <div class="numNumber">{{ apartment.comments_count }}</div>
                  </div>
                </div>
                <img
                  :src="apartment.avatar"
                  :alt="apartment.content"
                  @error="handleImageError"
                />
              </div>
              <div class="propertyContent">
                <div class="contanteHeader">
                  <div class="propertyCategory">
                    {{ apartment.main_category }}
                    <span v-if="apartment.main_category_en == 'request'">{{
                      apartment.request_type
                    }}</span>
                    - {{ apartment.category }}
                  </div>
                  <div class="propertyUpload">
                    <div class="propertyUploadIcon">
                      <VsxIcon
                        iconName="Calendar"
                        :size="14"
                        color="#0096c7"
                        type="linear"
                      />
                    </div>
                    <div class="propertyUploadTitle">
                      {{ apartment.created_fa }}
                    </div>
                  </div>
                </div>
                <div class="contentMain">
                  <div class="propertyTitle">
                    {{
                      apartment.content.length > 34
                        ? apartment.content.slice(0, 34) + "..."
                        : apartment.content
                    }}
                  </div>
                  <div class="propertyLocation">
                    <div class="locationIcon">
                      <i class="fa-solid fa-location-dot"></i>
                    </div>
                    <div class="locationTitle">
                      {{ apartment.address }}
                    </div>
                  </div>
                  <div class="contentFeaturesWrapper">
                    <div
                      v-if="
                        apartment.feature && apartment.feature.includes('fast')
                      "
                      class="featuresThumb fast"
                    >
                      <i class="fa-solid fa-bolt"></i>
                      <span>فوری</span>
                    </div>
                    <div
                      v-if="
                        apartment.feature &&
                        apartment.feature.includes('exchangeable')
                      "
                      class="featuresThumb exchange"
                    >
                      <i class="fa-solid fa-rotate"></i>
                      <span>قابل معاوضه</span>
                    </div>
                    <div
                      v-if="
                        apartment.feature &&
                        (apartment.feature.includes('single') ||
                          apartment.feature.includes('student'))
                      "
                      class="featuresThumb single"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                        />
                        <path
                          d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                        />
                        <path
                          d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                        />
                      </svg>
                      <span>دانشجو/مجرد</span>
                    </div>
                  </div>
                  <div class="contentPriceWrapper">
                    <div
                      class="priceWrapper"
                      v-if="
                        apartment.main_category_en != 'rent' &&
                        !(
                          apartment.main_category_en == 'request' &&
                          apartment.request_type_en == 'rent'
                        )
                      "
                    >
                      <div
                        class="pricecTitle"
                        v-if="apartment.main_category_en == 'trade'"
                      >
                        قیمت فروش:
                      </div>
                      <div
                        class="pricecTitle"
                        v-if="apartment.main_category_en == 'request'"
                      >
                        قیمت خرید:
                      </div>
                      <div
                        v-if="apartment.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ apartment.total_price }}
                      </div>
                      <div
                        v-if="apartment.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ apartment.total_price }} تا
                        {{ apartment.total_price_max }}
                      </div>
                    </div>
                    <div
                      class="priceWrapper"
                      v-if="
                        apartment.main_category_en == 'rent' ||
                        (apartment.main_category_en == 'request' &&
                          apartment.request_type_en == 'rent')
                      "
                    >
                      <div class="pricecTitle">مبلغ رهن:</div>
                      <div
                        v-if="apartment.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ apartment.mortgage_price }}
                      </div>
                      <div
                        v-if="apartment.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ apartment.mortgage_price }} تا
                        {{ apartment.mortgage_price_max }}
                      </div>
                    </div>
                    <div
                      class="priceWrapper"
                      v-if="
                        apartment.main_category_en == 'rent' ||
                        (apartment.main_category_en == 'request' &&
                          apartment.request_type_en == 'rent')
                      "
                    >
                      <div class="pricecTitle">مبلغ اجاره:</div>
                      <div
                        v-if="apartment.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ apartment.rent_price }}
                      </div>
                      <div
                        v-if="apartment.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ apartment.rent_price }} تا
                        {{ apartment.rent_price_max }}
                      </div>
                    </div>
                  </div>
                  <div class="realStateInfoWrapper">
                    <div class="realStateInfo">
                      <div class="infoPic">
                        <img :src="apartment.branch_avatar" alt="" />
                      </div>
                      <div
                        v-if="apartment.branch_title != '-'"
                        class="infoTitle"
                      >
                        {{ apartment.branch_title }}
                      </div>
                      <div v-else class="infoTitle">
                        {{ apartment.nickname }}
                      </div>
                    </div>
                    <div class="realStateBtn">
                      <div class="followBtn">
                        <div class="btnTitle">جزئیات</div>
                        <div class="btnIcon">
                          <i class="fas fa-arrow-left"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="filteredProperties == '' && !isLoading" class="ShowToUSer">
            <img src="/img/notfound.png" alt="" />
            <p style="font-size: 16px">ملکی یافت نشد</p>
          </div>
        </el-scrollbar>
      </div>
      <div class="MapLeftAllShowMapToUSer">
        <filterBox @reload="load_post('first')"></filterBox>
        <div v-if="LoadingMap" class="ShowNeshanMapToUserLoading">
          <span class="loader"></span>
        </div>

        <div
          id="map"
          ref="mapContainer"
          style="height: 100vh"
        ></div>
      </div>

      <div @click="OpenMenu" class="ShowClickToSeeMelk">نمایش آگهی‌ها</div>
    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import L from "leaflet";
import "leaflet.markercluster";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";
import filterBox from "@/components/filterBox/filterBox.vue";
import { Skeletor } from "vue-skeletor";
import axios from "axios";

try {
  if (maplibregl) {
    maplibregl.setRTLTextPlugin(
      "./js/mapbox-gl-rtl-text.js",
      null,
      true,
    );
  }
} catch (_e) {
  console.error(_e)
}

export default {
  name: "mapMelkMapir",
  components: {
    filterBox,
    Skeletor,
  },
  data() {
    return {
      map: null,
      windowWidth: window.innerWidth,
      isDarkMode: false,
      LoadingMap: true,
      isBackAction: false,
      showList: false,
      center: { latitude: 36.5482, longitude: 52.6786 },
      filteredProperties: [],
      post_list: [],
      fillter: {
        main_category: "all",
        category: "all",
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "map",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: "get",
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
        center_lat: null,
        center_lng: null,
        radius_km: null,
      },
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,

      markers: [],
      markerClusterGroup: null,
      circle: null,

      lastRequestedCenter: null,
      lastRequestedRadiusKm: null,
      moveDebounceMs: 700,
      moveDistanceThresholdKm: 0.3,
      radiusChangeThresholdRatio: 0.12,
      currentRequestSource: null,
      debouncedMapRequest: null,
      dataPendingCenter: null,
      dataPendingRadiusKm: null,

      initialZoom: 13,
      mapirToken: "",
      mapInitStarted: false,
      mapInitialized: false,
    };
  },
  computed: {
    closeBtn1() {
      return this.$route.query.files === "active" || this.windowWidth > 1000;
    },
  },
  watch: {
    "$store.state.c_set": {
      handler() {
        if (this.mapInitStarted) return;

        const c_set = this.$store.state.c_set;
        if (!c_set) return;

        const token =
          c_set.map_info?.mapir_key ||
          c_set.mapir_key ||
          "";

        const serviceKey =
          c_set.map_info?.map_service ||
          c_set.map_service ||
          "";

        if (!token && !serviceKey) return;

        this.mapirToken = token;
        this.mapInitStarted = true;

        this.$nextTick(() => {
          this.initMapirMap();
        });
      },
      immediate: true,
    },
  },

  methods: {
    mapGetCenter() {
      if (!this.map) return null;
      const c = this.map.getCenter();
      return { lat: c.lat, lng: c.lng };
    },

    mapGetBounds() {
      if (!this.map) return null;
      const b = this.map.getBounds();
      const ne = b.getNorthEast();
      const sw = b.getSouthWest();
      return {
        ne: { lat: ne.lat, lng: ne.lng },
        sw: { lat: sw.lat, lng: sw.lng },
      };
    },

    initMapirMap() {
      if (this.mapInitialized) return;
      try {
        if (!this.$refs.mapContainer) {
          setTimeout(() => this.initMapirMap(), 50);
          return;
        }

        this.map = L.map(this.$refs.mapContainer, {
          center: [this.center.latitude, this.center.longitude],
          zoom: this.initialZoom,
          minZoom: 4,
          maxZoom: 19,
        });

        if (this.mapirToken) {
          L.maplibreGL({
            style:
              "https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=" +
              this.mapirToken,
            transformRequest: (url) => {
              return {
                url: url,
                headers: { "x-api-key": this.mapirToken },
              };
            },
          }).addTo(this.map);
        } else {
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(this.map);
        }

        this.circle = L.circle([this.center.latitude, this.center.longitude], {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.1,
          radius: 5000,
        }).addTo(this.map);

        this.markerClusterGroup = L.markerClusterGroup({
          chunkedLoading: true,
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
          disableClusteringAtZoom: 19,
          maxZoom: 19,
          animate: true,
          animateAddingMarkers: true,
          iconCreateFunction: function (cluster) {
            return L.divIcon({
              html: "<div><span>" + cluster.getChildCount() + "</span></div>",
              className: "custom-cluster-marker",
              iconSize: L.point(40, 40),
            });
          },
        });

        this.map.addLayer(this.markerClusterGroup);

        this.map.on("moveend", this.onMapChanged);
        this.map.on("zoomend", this.onMapChanged);

        this.mapInitialized = true;

        this.$nextTick(() => {
          setTimeout(() => {
            try {
              this.map.invalidateSize(true);
              if (this.post_list && this.post_list.length) {
                this.addMarkers();
                this.updateCircle();
              }
            } catch (e) {
              console.log("e", e);
            }
          }, 100);
        });

        setTimeout(() => {
          this.LoadingMap = false;
          const center = this.mapGetCenter();
          const radiusKm = this.calculateViewportRadius() / 1000;
          if (center && radiusKm > 0) {
            this.dataPendingCenter = center;
            this.dataPendingRadiusKm = radiusKm;
            this.requestPostsForPendingMap();
          }
        }, 600);
      } catch (error) {
        console.error("Error initializing map.ir map:", error);
        this.LoadingMap = false;
      }
    },

    destroyMap() {
      try {
        if (this.map) {
          this.map.off("moveend", this.onMapChanged);
          this.map.off("zoomend", this.onMapChanged);
          this.map.remove();
          this.map = null;
        }
        this.markers = [];
        this.markerClusterGroup = null;
        this.mapInitialized = false;
        this.mapInitStarted = false;
      } catch (e) {
        console.error(e);
      }
    },

    addMarkers() {
      if (!this.map || !this.markerClusterGroup) return;
      this.markerClusterGroup.clearLayers();
      this.markers = [];
      const markersToAdd = [];

      this.post_list.forEach((melk, index) => {
        if (melk.lat && melk.lng) {
          try {
            const circleMarker = L.circleMarker(
              [parseFloat(melk.lat), parseFloat(melk.lng)],
              {
                radius: 8,
                fillColor: "#2196F3",
                color: "#fff",
                weight: 2,
                opacity: 1,
                fillOpacity: 0.8,
              },
            );

            const popupContent = document.createElement("div");
            popupContent.className = "marker-popup";
            popupContent.style.cursor = "pointer";
            popupContent.innerHTML = `
              <img src="${
                melk.avatar
              }" style="width: 100px; height: 100px; object-fit: cover;">
              <div class="marker-popup-content">
                <h4>${melk.content}</h4>
                ${
                  melk.main_category_en == "trade"
                    ? `<p>قیمت: ${melk.total_price}</p>`
                    : ""
                }
                ${
                  melk.main_category_en == "rent"
                    ? `<p>رهن: ${melk.mortgage_price}</p><p>اجاره: ${melk.rent_price}</p>`
                    : ""
                }
                <p>${melk.main_category} - ${melk.category}</p>
              </div>
            `;

            popupContent.addEventListener("click", () => {
              this.showPost(melk, index);
            });

            circleMarker.bindPopup(popupContent, {
              maxWidth: 300,
              className: "custom-popup",
              offset: [0, -10],
            });

            markersToAdd.push(circleMarker);
            this.markers.push(circleMarker);
          } catch (error) {
            console.error("Error adding marker:", error);
          }
        }
      });

      try {
        this.markerClusterGroup.addLayers(markersToAdd);
      } catch (e) {
        setTimeout(() => {
          try {
            if (this.map && this.markerClusterGroup) {
              this.map.invalidateSize(true);
              this.markerClusterGroup.addLayers(markersToAdd);
            }
          } catch (err) {
            console.log("err", err);
          }
        }, 50);
      }
    },

    updateCircle() {
      if (!this.map) return;
      const centerObj = this.mapGetCenter();
      const radiusMeters = this.calculateViewportRadius();

      if (this.circle) this.circle.remove();
      this.circle = L.circle([centerObj.lat, centerObj.lng], {
        radius: radiusMeters,
        color: "rgba(5, 5, 5, 0)",
        fillColor: "rgba(5, 5, 5, 0)",
        fillOpacity: 0,
        weight: 1,
        interactive: false,
        pane: "shadowPane",
      }).addTo(this.map);
      if (this.markerClusterGroup) this.markerClusterGroup.bringToFront();

      this.filteredProperties = this.getPropertiesWithinCircle(
        this.post_list,
        {
          latitude: centerObj.lat,
          longitude: centerObj.lng,
        },
        radiusMeters,
      );
    },

    calculateViewportRadius() {
      if (!this.map) return 0;
      try {
        const center = this.map.getCenter();
        const bounds = this.map.getBounds();
        const ne = bounds.getNorthEast();
        return center.distanceTo(ne);
      } catch (e) {
        return 0;
      }
    },

    getPropertiesWithinCircle(post_list, centerCoordinates, radius) {
      if (!post_list || !centerCoordinates || isNaN(radius)) {
        return [];
      }
      const propertiesInCircle = [];
      const [centerLng, centerLat] = [
        centerCoordinates.longitude,
        centerCoordinates.latitude,
      ];
      post_list.forEach((property) => {
        if (property.lat && property.lng) {
          const propertyLng = parseFloat(property.lng);
          const propertyLat = parseFloat(property.lat);
          const distance = this.calculateDistance(
            centerLat,
            centerLng,
            propertyLat,
            propertyLng,
          );
          if (distance <= radius / 1000) {
            propertiesInCircle.push(property);
          }
        }
      });
      return propertiesInCircle;
    },

    calculateDistance(lat1, lng1, lat2, lng2) {
      if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2)) {
        return Infinity;
      }
      const R = 6371;
      const dLat = this.degreesToRadians(lat2 - lat1);
      const dLng = this.degreesToRadians(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.degreesToRadians(lat1)) *
          Math.cos(this.degreesToRadians(lat2)) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },

    degreesToRadians(deg) {
      return deg * (Math.PI / 180);
    },

    checkWindowSize() {
      this.windowWidth = window.innerWidth;
    },

    debounce(fn, wait) {
      let timeout = null;
      return (...args) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          timeout = null;
          fn.apply(this, args);
        }, wait);
      };
    },

    onMapChanged() {
      const centerObj = this.mapGetCenter();
      if (!centerObj) return;
      const radiusMeters = this.calculateViewportRadius();
      const radiusKm = radiusMeters / 1000;

      const prev = this.lastRequestedCenter;
      let shouldRequest = true;

      if (prev && this.lastRequestedRadiusKm != null) {
        const movedKm = this.calculateDistance(
          prev.lat,
          prev.lng,
          centerObj.lat,
          centerObj.lng,
        );
        const radiusChangeRatio =
          Math.abs(radiusKm - this.lastRequestedRadiusKm) /
          (this.lastRequestedRadiusKm || 1);

        if (
          movedKm < this.moveDistanceThresholdKm &&
          radiusChangeRatio < this.radiusChangeThresholdRatio
        ) {
          shouldRequest = false;
        }
      }

      this.updateCircle();

      if (shouldRequest) {
        this.dataPendingCenter = { lat: centerObj.lat, lng: centerObj.lng };
        this.dataPendingRadiusKm = radiusKm;
        if (this.debouncedMapRequest) this.debouncedMapRequest();
      }
    },

    async requestPostsForPendingMap() {
      if (!this.dataPendingCenter || this.dataPendingRadiusKm == null) return;
      if (this.dataPendingRadiusKm <= 0) return;
      const center = this.dataPendingCenter;
      const radiusKm = this.dataPendingRadiusKm;

      try {
        if (this.currentRequestSource) {
          try {
            this.currentRequestSource.cancel("canceled by new request");
          } catch (e) {
            console.log(e);
          }
        }
      } catch (e) {
        console.log(e);
      }

      let cancelSource = null;
      if (axios.CancelToken) {
        cancelSource = axios.CancelToken.source();
        this.currentRequestSource = cancelSource;
      } else {
        this.currentRequestSource = null;
      }

      const payload = { ...this.fillter };
      payload.center_lat = center.lat;
      payload.center_lng = center.lng;
      payload.radius_km = radiusKm;
      payload.page = 1;
      payload.per_page = "get";
      payload.view_mode = "map";
      if (this.$store.state.auth.loggedIn)
        payload.user_id = this.$store.state.auth.uid;

      this.isLoading = true;
      this.loadmore_loading = true;

      try {
        const axiosOptions = {};
        if (cancelSource) axiosOptions.cancelToken = cancelSource.token;

        const response = await axios.post(
          this.$store.getters.baseUrl + "/public-post-list",
          payload,
          axiosOptions,
        );

        if (
          response.data &&
          response.data.result &&
          response.data.result !== 0
        ) {
          this.post_list = response.data.data.list || [];

          this.lastRequestedCenter = { lat: center.lat, lng: center.lng };
          this.lastRequestedRadiusKm = radiusKm;

          if (this.map) {
            this.addMarkers();
            this.updateCircle();
          }

          if (response.data.data.total_page == payload.page) {
            this.loadmore = false;
          } else {
            this.loadmore = true;
          }
        } else {
          this.post_list = [];
          this.loadmore = false;
        }
      } catch (err) {
        if (axios.isCancel && axios.isCancel(err)) {
          console.error("Error fetching posts for map:");
        } else {
          console.error("Error fetching posts for map:", err);
        }
      } finally {
        this.isLoading = false;
        this.loadmore_loading = false;
        this.currentRequestSource = null;
      }
    },

    showPost(post, index) {
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", this.post_list[index]);
      this.$router.push(`/details/${post.id}`);
    },

    OpenMenu() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ["files"]: "active",
        },
      });
      this.showList = true;
      const element = document.querySelector(".AllShowMapToUSer");
      if (element) element.style.zIndex = "999999999";
    },

    closeBtn() {
      history.back();
      this.showList = false;
      const element = document.querySelector(".AllShowMapToUSer");
      if (element) element.style.zIndex = "300";
    },

    async load_post(param) {
      this.$store.dispatch("checkPostFillter");
      if (this.$store.getters.post_fillter.length > 0) {
        this.fillter = this.$store.getters.post_fillter[0];
        const newQuery = { ...this.$route.query };
        delete newQuery.feature;
        delete newQuery.cat;
        this.$router.replace({ query: newQuery });
      } else {
        if (this.$route.query.cat || this.$route.query.feature) {
          if (this.$route.query.cat)
            this.fillter.category = this.$route.query.cat;
          if (this.$route.query.feature) {
            localStorage.removeItem("post_fillter");
            if (this.$route.query.feature == "request")
              this.fillter.main_category = "request";
            if (this.$route.query.feature == "fast") this.fillter.fast = true;
            if (this.$route.query.feature == "exchangeable")
              this.fillter.exchangeable = true;
            if (this.$route.query.feature == "student")
              this.fillter.student = true;

            setTimeout(() => {
              this.$store.commit("post_fillter_set", [this.fillter]);
            }, 1000);
          }
        }
      }

      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.per_page = "get";
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }
      if (this.$store.state.auth.loggedIn)
        this.fillter.user_id = this.$store.state.auth.uid;

      this.fillter.view_mode = "map";
      try {
        const response = await axios.post(
          this.$store.getters.baseUrl + "/public-post-list",
          this.fillter,
        );
        if (response.data.result == 0) {
          if (param != "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.post_list = response.data.data.list;
          if (response.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }
          if (this.map) {
            this.addMarkers();
            this.updateCircle();
          }
        }
        this.isLoading = false;
        this.loadmore_loading = false;
      } catch (error) {
        console.error("Error loading posts:", error);
        this.isLoading = false;
        this.loadmore_loading = false;
      }
    },
  },

  created() {
    this.debouncedMapRequest = this.debounce(() => {
      this.requestPostsForPendingMap();
    }, this.moveDebounceMs);
  },

  async mounted() {
    window.addEventListener("resize", this.checkWindowSize);
    this.checkWindowSize();

    this.popupClickHandler = (event) => {
      this.showPost(event.detail);
    };

    document.addEventListener("showPostFromPopup", this.popupClickHandler);
  },

  beforeUnmount() {
    this.destroyMap();

    try {
      if (this.currentRequestSource && this.currentRequestSource.cancel) {
        this.currentRequestSource.cancel("component unmount");
      }
    } catch (e) {
      console.log(e);
    }

    document.removeEventListener("showPostFromPopup", this.popupClickHandler);
    window.removeEventListener("resize", this.checkWindowSize);
  },
};
</script>

<style lang="scss" scoped>
.classShowApartmentSow {
  display: grid;
  grid-template-columns: 55% 40%;
  justify-content: space-between;
  min-height: 100px;
}

.classShowApartmentSow {
  margin-top: 0 !important;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 0.375rem;
  border: 1px solid rgb(209, 213, 219);
  background: #fff !important;
  box-shadow: 0 1px 2px 0 rgb(0, 0, 0, 0.1);
}
.classShowApartmentSow img {
  height: 130px;
}
.classShowApartmentSow h1 {
  white-space: inherit !important;
}

.MapLeftAllShowMapToUSer {
  position: relative;
}

@media (min-width: 1100px) {
  .TopShowBackToPage {
    display: none !important;
  }
}

:deep(.custom-cluster-marker) {
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid #0096c7;
  border-radius: 5px;
  color: #000;
  height: 28px !important;
  width: 50px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "iranyekanB";

  div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  span {
    font-size: 13px;
  }
}

.dark {
  .propertyThumb {
    box-shadow: 0 0 6px rgba(255, 255, 255, 0.15);

    .propertyContent {
      .contanteHeader {
        .propertyCategory {
          background: #25292e;
        }

        .propertyUpload {
          background: #25292e;

          .propertyUploadTitle {
            color: #fff;
          }
        }
      }

      .contentMain {
        .propertyTitle {
          color: #fff;
        }

        .propertyLocation {
          color: #7a7f8d;
        }

        .contentPriceWrapper {
          .priceWrapper {
            .priceTitle {
              color: #7a7f8d;
            }

            .priceValue {
              color: #fff;
            }
          }
        }

        .realStateInfoWrapper {
          border-top: 1px solid #2f2f2f;

          .realStateInfo {
            .infoTitle {
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.propertyThumb {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  margin-bottom: 32px;
  cursor: pointer;

  .propertyPic {
    position: relative;
    width: 100%;
    aspect-ratio: 3/2;

    img {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 0;
    }

    .swiper {
      height: 100%;

      .swiper-wrapper {
        height: 100%;
      }

      .swiper-slide {
        width: 100%;
        height: 100%;
      }

      .swiper-pagination {
        bottom: 14px !important;
      }

      .swiper-pagination-bullet {
        background: #fff !important;
        opacity: 0.4 !important;
      }

      .swiper-pagination-bullet.swiper-pagination-bullet-active {
        opacity: 1 !important;
      }

      .swiper-button-prev {
        width: 32px;
        height: 32px;
        display: flex;
        border-radius: 50%;
        align-items: center;
        opacity: 0;
        pointer-events: none;
        background-color: #fff;
        border: 1px solid #d8d8d8;
        transition: opacity 0.14s ease-in-out;
      }

      .swiper-button-prev::after {
        font-size: 0.85rem;
        color: #0e1011;
      }

      .swiper-button-next {
        width: 32px;
        height: 32px;
        display: flex;
        border-radius: 50%;
        opacity: 0;
        pointer-events: none;
        align-items: center;
        background-color: #fff;
        border: 1px solid #d8d8d8;
        transition: opacity 0.14s ease-in-out;
      }

      .swiper-button-next::after {
        font-size: 0.85rem;
        color: #0e1011;
      }

      &:hover {
        .swiper-button-prev {
          opacity: 1;
          pointer-events: auto;
        }

        .swiper-button-prev.swiper-button-disabled {
          opacity: 0.35 !important;
        }

        .swiper-button-next {
          opacity: 1;
          pointer-events: auto;
        }

        .swiper-button-next.swiper-button-disabled {
          opacity: 0.35 !important;
        }
      }
    }

    .propertyNums {
      position: absolute;
      top: 8px;
      left: 8px;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row-reverse;
        height: 32px;
        padding: 0 6px;
        gap: 6px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 5px;

        .numsICON {
          svg {
            fill: #fff;
            stroke: #fff;
            width: 20px;
            height: 20px;
          }
        }

        .numNumber {
          color: #f1f1f1;
          font-size: 0.9rem;
        }
      }
    }
  }

  .propertyContent {
    padding: 12px;
    padding-bottom: 16px;

    .contanteHeader {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .propertyCategory {
        padding: 4px 8px;
        border-radius: 24px;
        background: #f7f7f7;
        font-size: 0.7rem;
        color: #0096c7;
      }

      .propertyUpload {
        padding: 4px 8px;
        border-radius: 24px;
        background: #f7f7f7;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        gap: 4px;

        .propertyUploadTitle {
          height: 14px;
          display: flex;
          align-items: center;
        }
      }
    }

    .contentMain {
      .propertyTitle {
        font-family: "iranyekan", sans-serif;
        font-size: 1.075rem;
        margin-top: 14px;
        margin-bottom: 8px;
      }

      .propertyLocation {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #4b5563;
        font-size: 0.75rem;
        margin-bottom: 8px;

        svg {
          stroke: #4b5563;
        }
      }

      .thumbOptions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 8px;
        margin-top: 12px;

        .thumbStatus {
          padding: 4px 8px;
          font-size: 0.75rem;
          line-height: 1.25rem;
          display: flex !important;
          align-items: center !important;
          gap: 4px;
          background: #0096c7;
          border-radius: 24px;
          color: #fff;
          height: 21px;
          white-space: nowrap !important;
        }

        .ownerStatus {
          padding: 4px 8px;
          font-size: 0.75rem;
          line-height: 1.25rem;
          display: flex !important;
          align-items: center !important;
          gap: 4px;
          background: #000;
          border-radius: 24px;
          color: #fff;
          height: 21px;
        }

        .thumbCategory {
          padding: 0 8px;
          font-size: 0.75rem;
          line-height: 1.25rem;
          background: #000;
          border-radius: 24px;
          color: #000;
          background: rgba(0, 0, 0, 0.1);
          height: 21px;
          display: flex;
          align-items: center;
        }

        .thumbMainCategory {
          padding: 0 8px;
          font-size: 0.75rem;
          line-height: 1.25rem;
          background: #000;
          border-radius: 24px;
          color: #000;
          background: rgb(243, 244, 246);
          height: 21px;
          display: flex;
          align-items: center;
        }
      }

      .contentPriceWrapper {
        margin-bottom: 12px;
        margin-top: 6px;

        .priceWrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;

          .pricecTitle {
            font-size: 0.85rem;
            color: #4b5563;
          }

          .priceValue {
            font-family: "iranyekanB", sans-serif;
            font-size: 0.95rem;
            text-align: left;
            margin-right: auto;
          }
        }
      }

      .realStateInfoWrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 12px;
        border-top: 1px solid #ededed;

        .realStateInfo {
          display: flex;
          align-items: center;
          gap: 6px;

          .infoPic {
            width: 42px;
            height: 42px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }

          .infoTitle {
            font-size: 0.85rem;
          }
        }

        .realStateBtn {
          flex-shrink: 0;

          .followBtn {
            padding: 8px 14px;
            background: #0096c7;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-size: 0.8rem;
            color: #fff;
            border-radius: 6px;
          }
        }
      }
    }

    .contentFooterFile {
      .propertyBtnsWrapper {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;

        .propertyBtn {
          width: 100%;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 0.875rem;
          line-height: 1.25rem;
          border-radius: 4px;
          cursor: pointer;

          &.detailsBtn {
            background: rgb(67, 56, 202);
            color: #fff;
          }

          &.editBtn {
            background: rgb(59, 130, 246);
            color: #fff;
          }

          &.deleteBtn {
            background: rgb(239, 68, 68);
            color: #fff;
          }
        }
      }
    }

    .contentFooter {
      display: flex;
      border-top: 1px solid #ededed;
      padding-top: 16px;

      .propertyOptions {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 1rem;
        width: 100%;

        .optionThumb {
          text-align: center;

          .optionIcon {
            flex-shrink: 0;
            text-align: center;
            color: #4b5563;
            font-size: 0.875rem;

            svg {
              width: 18px;
              height: 18px;
              stroke: #4b5563;
              margin: 0 auto;
            }
          }

          .optionTitle {
            color: #4b5563;
            font-size: 0.875rem;
            line-height: 1.25rem;
            margin-top: 0.25rem;
          }
        }
      }
    }
  }
}

.apartmentsListContainer {
  width: 90%;
  margin: 0 auto;
}

@media (min-width: 1000px) {
  .createMelkHeader {
    display: none !important;
  }
}
</style>
